import { memo } from 'react';
import { MenuGalleryLink, MenuGalleryList, MenuListItem } from "./sub-menu.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SubMenuWithGallery = function SubMenuWithGallery(_ref) {
  var items = _ref.items,
    onItemClick = _ref.onItemClick;
  return /*#__PURE__*/_jsx(MenuGalleryList, {
    children: items === null || items === void 0 ? void 0 : items.map(function (menuItem) {
      return /*#__PURE__*/_jsx(MenuListItem, {
        children: /*#__PURE__*/_jsx(MenuGalleryLink, {
          onClick: function onClick(event) {
            return onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick({
              event: event,
              item: menuItem
            });
          },
          href: menuItem.href,
          children: /*#__PURE__*/_jsxs(_Fragment, {
            children: [menuItem.Icon && /*#__PURE__*/_jsx(menuItem.Icon, {}), menuItem.label]
          })
        })
      }, menuItem.id);
    })
  });
};
export default /*#__PURE__*/memo(SubMenuWithGallery);